export default __webpack_public_path__ + "static/media/BCI_Robot.5d3d8bbb.webp";